// Available auditors for re-audit assignment
export const AVAILABLE_AUDITORS = ["johndoe", "janedoe", "bobsmith", "alicejones", "mikebrown"];

// Audit fields for filtering (core 6 fields only)
export const AUDIT_FIELDS = [
  "Incident Location",
  "Primary Impact",
  "Detailed Body Part",
  "Primary Object",
  "Secondary Object",
  "Risk Hazard",
];

// Core fields for defect calculation (excluding root_cause and process_path)
export const CORE_FIELD_TYPES = [
  "incident_location",
  "primary_impact",
  "detailed_body_part",
  "primary_object",
  "secondary_object",
  "risk_hazard",
];

// All fields for processing (including root_cause and process_path)
export const ALL_FIELD_TYPES = [...CORE_FIELD_TYPES, "root_cause", "process_path"];

// Core fields for UI display
export const CORE_FIELDS = [
  "Incident Location",
  "Primary Impact",
  "Detailed Body Part",
  "Primary Object",
  "Secondary Object",
  "Risk Hazard",
];

// Colors for styling
export const COLORS = {
  BLUE: "#0073bb",
  RED: "#d13212",
};
